import { Control, FieldPath, FieldValues } from 'react-hook-form'

import { Checkbox } from '../checkbox'

import { FormControl, FormField, FormItem, FormLabel } from '.'

interface FormCheckboxProps<T extends FieldValues> {
    control: Control<T>
    name: FieldPath<T>
    label: React.ReactNode
    className?: string
    disabled?: boolean
}

export default function FormCheckbox<T extends FieldValues>({
    control,
    name,
    label,
    className,
    disabled,
}: FormCheckboxProps<T>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => {
                const { onChange, value, ...rest } = field
                return (
                    <FormItem className={className}>
                        <div className={`just flex flex-row items-center space-x-3`}>
                            <FormControl>
                                <Checkbox
                                    {...rest}
                                    checked={value !== undefined ? !!value : false}
                                    disabled={disabled}
                                    onCheckedChange={v => {
                                        onChange(v)
                                    }}
                                />
                            </FormControl>

                            <FormLabel className="mb-0">{label}</FormLabel>
                        </div>
                    </FormItem>
                )
            }}
        />
    )
}
